<template>
  <div id="app">
    <router-view></router-view>
    <form-grid-modal v-if="isFormGridOpen" :toggleFormGridVisibilityCallback="toggleFormGridVisibility" :separateRaceHorseIndex="selectedFormGridHorseIndex"></form-grid-modal>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';
  import FormGridModal from './components/FormGridModal';

  export default {
    name: 'app',
    components: {
      FormGridModal
    },
    computed: mapState(['selectedFormGridHorseIndex', 'isFormGridOpen']),
    methods: {
      toggleFormGridVisibility() {
        this.setIsFormGridOpen(!this.isFormGridOpen);
      },
      ...mapMutations(['setIsFormGridOpen'])
    }
  }
</script>

<style>
</style>
